import BaseModel from './BaseModel'
import { fk } from 'redux-orm'
import axiosInstance from 'api/axios.config'
import {
  PLAYLIST_ENTRY_CREATED,
  START_PLAYLIST_ENTRY_SORT,
  PLAYLIST_ENTRY_DELETED
} from '../redux/actions/playlistEntries'

class PlaylistEntries extends BaseModel {
  static reducer (action, PlaylistEntry, session) {
    let playlist

    switch (action.type) {
      case PLAYLIST_ENTRY_CREATED:
        const currentNumEntries = PlaylistEntry.filter(
          entry => entry.playlist === action.playlistUUID
        ).count()
        PlaylistEntry.create({
          playlist: action.playlistUUID,
          planEntry: action.planEntryId,
          orderBy: currentNumEntries,
          createdAt: action.createdAt
        })
        playlist = session.Playlist.withId(action.playlistUUID)
        playlist.update({
          entryCount: playlist.entryCount + 1,
          entryIds: [action.planEntryId, ...playlist.entryIds]
        })
        break
      case PLAYLIST_ENTRY_DELETED:
        const playlistEntry = PlaylistEntry.withId(action.playlistEntryId)
        playlist = session.Playlist.withId(playlistEntry.playlist.uuid)
        playlist.update({
          entryCount: playlist.entryCount - 1
        })
        playlistEntry.delete()
        break
      case START_PLAYLIST_ENTRY_SORT:
        // TODO: Find a quicker way to update order in redux state

        const { oldIndex, newIndex } = action.sortedEntryObj
        const entryBeingReordered = PlaylistEntry.get({
          playlist: action.uuid,
          orderBy: oldIndex
        })

        // moved forward in list
        if (newIndex > oldIndex) {
          const entriesToUpdate = PlaylistEntry.all().filter(
            playlistEntry =>
              playlistEntry.playlist === action.uuid &&
              playlistEntry.orderBy <= newIndex &&
              playlistEntry.orderBy > oldIndex
          )
          entriesToUpdate.toModelArray().forEach(entry => {
            entry.update({ orderBy: entry.orderBy - 1 })
          })
        } else {
          const entriesToUpdate = PlaylistEntry.all().filter(
            playlistEntry =>
              playlistEntry.playlist === action.uuid &&
              playlistEntry.orderBy < oldIndex &&
              playlistEntry.orderBy >= newIndex
          )
          entriesToUpdate.toModelArray().forEach(entry => {
            entry.update({ orderBy: entry.orderBy + 1 })
          })
        }

        entryBeingReordered.update({
          orderBy: newIndex
        })

        break
    }
  }

  static createNew (playlistUUID, planEntryId) {
    return axiosInstance.post(`/playlists/${playlistUUID}/entries`, {
      plan_entry_id: planEntryId
    })
  }

  deleteEntry () {
    return axiosInstance.delete(
      `/playlists/${this.playlist.uuid}/entries/${this.planEntry.id}`
    )
  }
}

PlaylistEntries.modelName = 'PlaylistEntries'
PlaylistEntries.apiPath = '/playlist/entries'
PlaylistEntries.fields = {
  playlist: fk('Playlist', 'playlistEntries'),
  planEntry: fk('PlanEntry', 'playlistEntries')
}

export default PlaylistEntries
